"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.switchProviderChainId = void 0;
const getProviderChainId_1 = require("./getProviderChainId");
const getAddEthereumChainParameters_1 = require("./getAddEthereumChainParameters");
const JsonRPCInvalidResponseError_1 = require("./JsonRPCInvalidResponseError");
/**
 * Change the provider's chain to a provided chain.
 * In case it returns an error that the chain does not exist, it will try to add it.
 * @param provider - The provider used to swith the chain
 * @param chainId - The chain id that is being changed
 * @returns A number representing the chain id
 */
function switchProviderChainId(provider, chainId) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            yield provider.request({
                method: 'wallet_switchEthereumChain',
                params: [{ chainId: '0x' + chainId.toString(16) }]
            });
            return chainId;
        }
        catch (switchError) {
            // This error code indicates that the chain has not been added to MetaMask.
            if (provider && (switchError === null || switchError === void 0 ? void 0 : switchError.code) === 4902) {
                try {
                    yield provider.request({
                        method: 'wallet_addEthereumChain',
                        params: [(0, getAddEthereumChainParameters_1.getAddEthereumChainParameters)(chainId)]
                    });
                    const newChainId = yield (0, getProviderChainId_1.getProviderChainId)(provider);
                    if (chainId !== newChainId) {
                        throw new Error('chainId did not change after adding network');
                    }
                    return chainId;
                }
                catch (addError) {
                    throw new Error(`Error adding network: ${addError.message}`);
                }
            } // We're throwing specific error for this message because we don't know how to reproduce it and we don't want to get logged
            else if ((switchError === null || switchError === void 0 ? void 0 : switchError.message) === 'JSON RPC response format is invalid') {
                throw new JsonRPCInvalidResponseError_1.JsonRPCInvalidResponseError(switchError === null || switchError === void 0 ? void 0 : switchError.message);
            }
            throw new Error(`Error switching network: ${switchError.message}`);
        }
    });
}
exports.switchProviderChainId = switchProviderChainId;
//# sourceMappingURL=switchProviderChainId.js.map